﻿/**
 * Emergency Modal popup functionality
 *
 */

(function ($) {
    $.fn.rlEmergencyModal = function () {
        var messageAccept = Boolean(sessionStorage.getItem('emergencyMode'));

        if (!messageAccept) {
            $('#emergencyModal').modal();

            $('#emergencyModal button').on('click', function () {
                sessionStorage.setItem("emergencyMode", "true");
                $('#emergencyModal button').off();
            });
        }        
    }
}(jQuery));